/**
 * Device detection utilities
 */

/**
 * Detects if the user is on a mobile device
 * @returns true if mobile, false if desktop
 */
export const isMobile = (): boolean => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

/**
 * Detects if the user is on an iOS device (iPhone, iPad, iPod).
 * Includes iPadOS 13+ which may report as Macintosh in the user agent.
 */
export const isIOS = (): boolean => {
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/i.test(ua)) {
    return true;
  }
  // iPadOS 13+ often reports as MacIntel with touch support
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
};
